<template>
  <div class="flex flex-col gap-4">
    <div class="rounded-xl overflow-hidden">
      <BaseRatio :ratio="1 / 3" size="cover">
        <div
          class="w-full h-full flex items-center justify-center bg-primary-100"
        >
          <img :src="category.background[0]?.url" class="w-full" />
        </div>
      </BaseRatio>
      <div
        class="relative bg-white w-full flex p-4 gap-4 justify-between flex-col md:flex-row lg:flex-col xl:flex-row"
      >
        <div
          class="flex-shrink-0 h-28 w-28 rounded-xl pb-1 -mt-24 md:mt-0 lg:-mt-24 xl:mt-0 border-white border-4 overflow-hidden"
        >
          <BaseRatio v-if="category.preview.length" :ratio="1" size="cover">
            <div
              class="w-full h-full flex items-center justify-center bg-primary-100"
            >
              <img :src="category.preview[0]?.url" class="w-full" />
            </div>
          </BaseRatio>
          <div
            v-else
            class="flex items-center justify-center h-full w-full bg-primary-100 text-6xl font-light text-primary"
          >
            {{ title.slice(0, 1) }}
          </div>
        </div>
        <div class="flex-1 mr-4 flex flex-col gap-1">
          <div
            class="flex gap-x-4 gap-y-1 flex-col md:flex-row lg:flex-col xl:flex-row"
          >
            <h1 class="text-2xl text-gray font-bold">{{ title }}</h1>
            <!-- TODO: subscriptions are not available yet -->
            <!-- <div
              class="flex items-center gap-1 whitespace-nowrap leading-8 text-gray-500"
            >
              <BaseIcon name="outline_user" size="xs" />
              {{ category.subscribers || 0 }}
              {{ $t('common.subscribers', category.subscribers || 0) }}
            </div> -->
          </div>
          <p class="line-clamp-3">{{ description }}</p>
        </div>
        <div v-if="$slots.buttons">
          <slot name="buttons" />
        </div>
        <!-- <BaseButton theme="primary" look="solid" class="w-min">
          {{ $t('common.subscribe') }} +
        </BaseButton> -->
      </div>
    </div>
    <div v-if="sorts" class="flex gap-2 bg-white rounded-xl px-4 py-2">
      <SidebarMenuItem
        v-for="item in sorts"
        :key="item.id"
        :item="item"
        theme="light"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Category } from '~/models/navigation'
import type { MenuItem } from '~/models/menu'

const i18n = useI18n()

const props = defineProps({
  category: {
    type: Object as PropType<Category>,
    required: true,
  },
  sorts: {
    type: Object as PropType<MenuItem[]> | null,
    default: null,
  },
})

const title = computed(() =>
  getFieldLocale(props.category.title, i18n.locale.value)
)
const description = computed(() =>
  getFieldLocale(props.category.description, i18n.locale.value)
)
</script>
